/**
 * The characters a written phone number is allowed to use.
 *
 * Digits with the separators people actually type — spaces, dashes, dots, brackets and a leading
 * plus for an international number. Letters are what this exists to stop: a name or a note pasted
 * into the phone box is the mistake worth catching.
 */
const PHONE_CHARACTERS = /^\+?[\d\s().-]+$/;

/**
 * The shortest and longest digit counts a real number has.
 *
 * Seven covers a local number written without its area code; fifteen is the E.164 maximum. Counted
 * on digits alone, so "027 000 0000" and "0270000000" are judged the same.
 */
const MIN_PHONE_DIGITS = 7;
const MAX_PHONE_DIGITS = 15;

export const PHONE_MESSAGE = 'Enter a phone number using digits only';

/** A `tel:` link for a number as people write it: digits only, keeping a leading `+`. */
export const getPhoneHref = (phone: string): string => {
	const trimmed = phone.trim();
	const digits = trimmed.replace(/\D/g, '');
	return `tel:${trimmed.startsWith('+') ? `+${digits}` : digits}`;
};

/** Whether a phone number is plausible. An empty value is not a phone number; callers decide if it is required. */
export const isValidPhone = (phone: string): boolean => {
	const trimmed = phone.trim();
	if (!PHONE_CHARACTERS.test(trimmed)) return false;
	const digits = trimmed.replace(/\D/g, '').length;
	return digits >= MIN_PHONE_DIGITS && digits <= MAX_PHONE_DIGITS;
};
